module.exports = __webpack_public_path__ + "static/media/(H)-Artesanato-14.b3f4eda5.jpg";